import { render, staticRenderFns } from "./GateForm.vue?vue&type=template&id=9a87043a&scoped=true&"
import script from "./GateForm.vue?vue&type=script&lang=js&"
export * from "./GateForm.vue?vue&type=script&lang=js&"
import style0 from "./GateForm.vue?vue&type=style&index=0&id=9a87043a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a87043a",
  null
  
)

export default component.exports